import React from "react";
import PropTypes from "prop-types";
import { KeyItem, KeyLabel, KeyMeaning } from "./_.styled";
import { Icon } from "@ebscois/react-component-library";

const ContentKeyItem = ({ icon, label, value, testId, style }) => (
  <KeyItem data-testid={testId}>
    {icon && (
      <Icon
        data-testid={icon.testId}
        icon={{
          glyph: icon.glyph,
          color: icon.color,
          size: icon.size,
        }}
      />
    )}
    {label && <KeyLabel keyStyle={style}>{label}</KeyLabel>}
    <KeyMeaning> = {value}</KeyMeaning>
  </KeyItem>
);

ContentKeyItem.propTypes = {
  label: PropTypes.string,
  icon: PropTypes.shape({
    glyph: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    size: PropTypes.string.isRequired,
    testId: PropTypes.string.isRequired,
  }),
  testId: PropTypes.string.isRequired,
  style: PropTypes.string,
  value: PropTypes.string.isRequired,
};

ContentKeyItem.displayName = "ContentKeyItem";

export default ContentKeyItem;
